// Utility functions for rendering and labeling routes.

import React from "react";
import { Route } from "react-router-dom";

// Returns the name of the active route for display in navbar
export function getActiveRoute(routes) {
  let activeRoute = "Default Brand Text";
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].collapse) {
      const collapseActiveRoute = getActiveRoute(routes[i].views);
      if (collapseActiveRoute !== activeRoute) {
        return collapseActiveRoute;
      }
    } else if (
      window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
    ) {
      return routes[i].name;
    }
  }
  return activeRoute;
}

// Filters and returns valid <Route> components for rendering
export function getRoutes(routes, userDetails) {
  return routes.flatMap((prop, key) => {
    if (
      prop.allowedRoles &&
      !prop.allowedRoles.includes(userDetails.user_role)
    ) {
      return [];
    }

    if (
      prop.showOnlyWhenRedirected &&
      window.location.href.indexOf(prop.layout + prop.path) === -1
    ) {
      return [];
    }

    if (prop.collapse) {
      return getRoutes(prop.views, userDetails);
    }

    if (prop.layout === "/main") {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    }

    return [];
  });
}
